import styled from '@emotion/styled'
import {
  DocumentCard,
  DocumentCardPreview,
  DocumentCardTitle,
  DocumentCardType,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTheme } from 'theme'

// const Title = styled.h3`
//   ${themeFont('xLarge')};
//   font-weight: normal;
//   text-align: center;
// `
export enum HOMEPAGE_ITEM_TYPE {
  big = 14,
  small = 10,
}
export interface IMenuItemProps {
  iconName: string
  routerPath: string
  itemName: string
  translation: string
  type: HOMEPAGE_ITEM_TYPE
  clickHandler: (name: string, fullPath: string) => void
  notificationCounter?: number
}
// const getPixelFromViewport = (viewport: number, percentage: number) =>
//   (viewport / 100) * percentage
// @ts-ignore
const Badge = styled.div`
  position: absolute;
  top: -15px;
  right: -15px;
  padding: 10px 17.5px;
  border-radius: 50%;
  background-color: rgb(163, 0, 22);
  color: white;
  font-size: 22px;
  font-weight: bold;
`

export const MenuItemView: React.FC<IMenuItemProps> = ({
  clickHandler,
  notificationCounter,
  ...itemProps
}) => {
  const theme = useTheme()
  // const { height: viewportHeight } = useWindowDimensions()
  return (
    <>
      <DocumentCard
        style={{
          maxWidth: '100%',
          minWidth: 0,
          maxHeight: '100%',
          minHeight: 0,
          padding: 0,
          margin: 0,
        }}
        aria-label="Main Menu Document Card "
        type={DocumentCardType.normal}
        onClick={(e) => {
          clickHandler(itemProps.itemName, itemProps.routerPath)
        }}
      >
        <DocumentCardPreview
          styles={{
            root: { backgroundColor: 'white', transform: 'scale(0.5,0.5)' },
          }}
          previewImages={[
            {
              previewIconProps: {
                iconName: itemProps.iconName,
                styles: {
                  root: {
                    fontSize: 100,
                    color: theme.palette.red,
                  },
                },
              },
            },
          ]}
        />
        <DocumentCardTitle
          styles={{
            root: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxSizing: 'content-box',
              flexGrow: '1',
              textAlign: 'center',
              paddingBottom: 25,
            },
          }}
          title={itemProps.translation}
          shouldTruncate={true}
        />
        {(itemProps.itemName === 'news' || itemProps.itemName === 'wiki') &&
          notificationCounter !== 0 && <Badge>{notificationCounter}</Badge>}
        {/* <Title>{itemProps.translation}</Title> */}
      </DocumentCard>
    </>
  )
}
